module.exports = __webpack_public_path__ + "static/media/R_AngelsOfAether_Promo_202.0e52942f.jpg";